<script setup lang="ts">
import {
  FunctionKey,
  FunctionName,
  UserPlanAvailabilityTable
} from '@WombatTechnology/nitte-time-lib'
import { FreePlan, ProPlan, TeamPlan } from './parts'

interface Props {
  focusOn: FunctionKey[]
  showProPlan?: boolean
  bodyHeight?: string
}
const props = withDefaults(defineProps<Props>(), {
  showProPlan: true
})
</script>

<template>
  <!-- PC -->
  <table class="desktop plan-table bg-white border-gray">
    <thead>
      <tr>
        <td class="position-relative">
          <div class="function-label or-ft-bold">機能</div>
        </td>
        <td><FreePlan /></td>
        <td v-if="props.showProPlan">
          <ProPlan />
        </td>
        <td>
          <TeamPlan />
        </td>
      </tr>
    </thead>
    <tbody :style="{ height: props.bodyHeight }">
      <tr
        v-for="[key, value] in Object.entries(UserPlanAvailabilityTable)"
        :key="key"
        :class="{
          focus: focusOn?.includes(key as keyof UserPlanAvailabilityTable)
        }"
      >
        <td>{{ FunctionName[key as keyof UserPlanAvailabilityTable] }}</td>
        <td>
          <div class="check-wrap">
            <img
              v-if="value.free === true"
              src="@/assets/plan-check-black.svg"
              alt="black-check"
            />
            <description v-else-if="!!value.free">
              {{ value.free }}
            </description>
          </div>
        </td>
        <td v-if="props.showProPlan">
          <div class="check-wrap">
            <img
              v-if="value.pro === true"
              src="@/assets/plan-check-main.svg"
              alt="black-check"
            />
            <description v-else-if="!!value.pro">
              {{ value.pro }}
            </description>
          </div>
        </td>
        <td>
          <div class="check-wrap">
            <img
              v-if="value.team === true"
              src="@/assets/plan-check-accent.svg"
              alt="black-check"
            />
            <description v-else-if="!!value.team">
              {{ value.team }}
            </description>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
  <!-- Mobile: そんなに気合い入れてない -->
  <section class="mobile">
    <FreePlan />
    <template v-if="props.showProPlan">
      <hr class="mg-top-24px" />
      <ProPlan />
    </template>
    <hr class="mg-top-24px" />
    <TeamPlan />
  </section>
</template>

<style scoped>
.plan-table {
  border-collapse: collapse;
}

th,
td {
  padding: var(--pd-row);
  vertical-align: middle;
  border: 1px solid var(--border-gray);
}

thead > tr > td {
  vertical-align: baseline;
}
.function-label {
  position: absolute;
  bottom: var(--base-8px);
  left: var(--base-16px);
}

thead,
tbody tr {
  display: table;
  width: 100%;
  table-layout: fixed; /* even columns width , fix width of table too*/
}
tbody {
  display: block;
  overflow: auto;
}
/* NOTE: チェックマークが上にずれるので調整 */
.check-wrap {
  display: flex;
}
/*  */
.scroll-right-margin {
  width: 15px;
  table-layout: fixed;
  padding: 0;
  border-left: none;
}

.focus {
  background: var(--bg-main);
}
</style>
